<template>
  <div class="mt-2">
    <b-button variant="primary" @click="triggerAddParameter">Add Parameter</b-button>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Max Score</th>
          <th>COs</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(parameter, paramIndex) in method.parameters" :key="paramIndex">
          <td>{{ paramIndex + 1 }}</td>
          <td>
            <b-form-input
              v-if="!parameter.id || parameter.isEditing"
              v-model="parameter.name"
              placeholder="Enter name"
              size="sm"
              :ref="`paramInput-${methodIndex}-${paramIndex}`"
              style="min-width: 300px;" 
            />
            <span v-else>{{ parameter.name }}</span>

            <small
              v-if="validation.parameters.$each[paramIndex].name.$dirty && validation.parameters.$each[paramIndex].name.$invalid"
              class="text-danger"
            >
              Name is required.
            </small>
          </td>
          <td>
            <b-form-input
              v-if="!parameter.id || parameter.isEditing"
              v-model.number="parameter.maximum_score"
              placeholder="Max score"
              size="sm"
            />
            <span v-else>{{ parameter.maximum_score }}</span>
            <small
              v-if="validation.parameters.$each[paramIndex].maximum_score.$dirty &&
                    validation.parameters.$each[paramIndex].maximum_score.$invalid"
              class="text-danger"
            >
              <span v-if="!validation.parameters.$each[paramIndex].maximum_score.required">Score is required.</span>
              <span v-else-if="!validation.parameters.$each[paramIndex].maximum_score.numeric">Score must be a number.</span>
            </small>
          </td>
          <td>
            <b-form-checkbox-group
              v-if="!parameter.id || parameter.isEditing"
              v-model="parameter.cos"
            >
              <b-form-checkbox
                v-for="(co, idx) in courseOutcomeOptions"
                :key="idx"
                :value="co.value"
              >
                {{ co.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
            <span v-else>{{ parameter.co_codes.join(', ') }}</span>
          </td>
          <td>
            <i
              v-if="!parameter.isEditing && parameter.id"
              class="far fa-edit text-info ml-3"
              style="font-size: 15px; cursor: pointer;"
              @click="startEditing(paramIndex)"
            ></i>

            <b-button
              v-if="!parameter.id || parameter.isEditing"
              variant="success"
              size="sm"
              @click="parameter.isEditing = true; $emit('saveParameter', methodIndex, paramIndex)"
            >
              {{ parameter.id ? 'Update' : 'Save' }}
            </b-button>

            <b-button
              v-if="!parameter.id || parameter.isEditing"
              variant="danger"
              size="sm"
              class="ml-2"
              @click="$emit('cancelParameter', methodIndex, paramIndex, parameter.id)"
            >
              Cancel
            </b-button>

            <i
              v-if="!parameter.isEditing && parameter.id"
              class="fas fa-trash text-danger ml-2"
              style="font-size: 15px; cursor: pointer;"
              @click="$emit('deleteParameter', parameter.id, paramIndex, methodIndex)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    method: Object,
    methodIndex: Number,
    courseOutcomeOptions: Array,
    validation: Object,
  },
  methods: {
    triggerAddParameter() {
      this.$emit('addParameter', this.methodIndex);
      this.$nextTick(() => {
        this.focusEditableInput();
      });
    },
    focusEditableInput() {
      this.method.parameters.forEach((param, paramIndex) => {
        if (!param.id || param.isEditing) {
          const refName = `paramInput-${this.methodIndex}-${paramIndex}`;
          const input = this.$refs[refName];
          if (input && input[0]) {
            input[0].focus();
          }
        }
      });
    },
    startEditing(paramIndex) {
      const param = this.method.parameters[paramIndex];
      param._original = {
        name: param.name,
        maximum_score: param.maximum_score,
        cos: Array.isArray(param.cos) ? [...param.cos] : [],
      };
      param.isEditing = true;
    }

  }
};
</script>
